import styled from 'styled-components';

export const VerticalDivider = styled.div`
  min-width: 1px;
  align-self: stretch;
  background-image: linear-gradient(
    to bottom,
    var(--background-gray-light) 0%,
    var(--line-gray) 50%,
    var(--background-gray-light)
  );
`;
